"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
class OrderStatus {
}
exports.OrderStatus = OrderStatus;
/**
 * The order is created but not ready to be processed
 */
OrderStatus.created = 'created';
/**
 * The order is ready to be processed.
 */
OrderStatus.readyForProcessing = 'ready-for-processing';
/**
 * Assembling the archive
 */
OrderStatus.assembling = 'assembling';
/**
 * Uploading archive to file area
 */
OrderStatus.uploading = 'uploading';
/**
 * Order is assembled and uploaded and is ready to be downloaded.
 */
OrderStatus.completed = 'completed';
/**
 * The order failed to be processed.
 */
OrderStatus.failed = 'failed';
/**
 * Archived - e.g the compiled package is removed and cannot
 * be downloaded any more.
 */
OrderStatus.archived = 'archived';
Object.seal(OrderStatus);
//# sourceMappingURL=order-status.js.map